import { render, staticRenderFns } from "./FilterDiagnosis.vue?vue&type=template&id=5bb6c4f0&scoped=true&lang=pug&"
import script from "./FilterDiagnosis.vue?vue&type=script&lang=js&"
export * from "./FilterDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./FilterDiagnosis.vue?vue&type=style&index=0&id=5bb6c4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6c4f0",
  null
  
)

export default component.exports